import PublicNav from '@/components/PublicNav';
import BackToTop from '@/components/BackToTop';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Zap, ArrowRight } from 'lucide-react';

const faqs = [
  { q: 'Flexa ni apa sebenarnya?', a: 'Flexa adalah panel SMM (Social Media Marketing) terbesar di Malaysia dengan lebih 3,351 servis untuk semua platform sosial media termasuk Instagram, TikTok, YouTube, Facebook, Telegram dan banyak lagi.' },
  { q: 'Macam mana cara nak order?', a: 'Sangat mudah! 1) Daftar akaun percuma, 2) Top up balance melalui FPX, GrabPay atau kad kredit, 3) Pilih servis dan masukkan link, 4) Klik order, delivery bermula secara automatik dalam beberapa minit.' },
  { q: 'Macam mana nak top up balance?', a: 'Pergi ke halaman Top Up dari dashboard. Pilih jumlah dan kaedah bayaran (FPX, GrabPay, atau kad kredit). Top up adalah instant, balance anda dikemaskini serta-merta.' },
  { q: 'Berapa lama order siap?', a: 'Setiap servis ada kelajuan delivery tersendiri. Kebanyakan order bermula dalam 0-1 jam dan siap dalam 24 jam. Ada servis yang bermula dalam 60 saat.' },
  { q: 'Macam mana nak isi link?', a: 'Untuk likes/views: tampal URL post penuh (contoh: https://instagram.com/p/xxx/). Untuk followers: tampal URL profil (contoh: https://instagram.com/username). Pastikan akaun anda public.' },
  { q: 'Selamat ke guna Flexa?', a: 'Ya! 100% selamat. Semua servis dihantar secara selamat melalui API rasmi. Kami tidak pernah minta password akaun anda. Data disulitkan dan privacy terjamin.' },
  { q: 'Apa itu status Partial?', a: 'Partial bermaksud sebahagian sahaja order berjaya dihantar. Baki yang tidak dihantar akan di-refund secara automatik ke balance anda.' },
  { q: 'Boleh ke cancel order?', a: 'Tidak, order tidak boleh dibatalkan setelah dibuat. Pastikan akaun anda public dan link betul sebelum order.' },
  { q: 'Apa itu Mass Order?', a: 'Mass Order membolehkan anda buat banyak order sekaligus. Format: ServiceID|Link|Quantity pada setiap baris. Semak halaman Servis untuk service ID.' },
  { q: 'Kaedah bayaran apa yang disokong?', a: 'Kami menyokong FPX (online banking Malaysia), GrabPay, Touch n Go, dan kad kredit/debit (Visa/Mastercard). Semua top up adalah instant.' },
  { q: 'Ada diskaun untuk reseller?', a: 'Ya! Sistem tier VIP kami memberikan diskaun automatik. Semakin banyak anda guna, semakin murah harga. Kami juga ada program affiliate dengan komisyen lifetime.' },
  { q: 'Macam mana nak hubungi support?', a: 'Anda boleh buat tiket sokongan dari dashboard, atau gunakan AI chat assistant Alia yang tersedia 24/7. Pasukan kami akan respond dalam 24 jam.' },
];

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-[#FCFAFF]">
      <Helmet>
        <title>Soalan Lazim (FAQ) - Panel SMM Malaysia | Flexa</title>
        <meta name="description" content="Jawapan kepada soalan lazim tentang Flexa SMM Panel Malaysia. Cara order, cara top up, kaedah bayaran, keselamatan, dan banyak lagi." />
        <link rel="canonical" href="https://flexaviral.com/faq" />
      </Helmet>
      <PublicNav />

      <div className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        <h1 className="text-2xl font-bold text-[#0F172A] mb-1">Soalan Lazim - Panel SMM Malaysia</h1>
        <p className="text-[#6B7280] mb-8">Jawapan kepada soalan popular tentang Flexa</p>

        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="bg-white border border-[#E9D5FF] rounded-xl px-5 transition-all duration-200" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-sm font-medium text-[#0F172A] hover:no-underline py-4">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#6B7280] pb-4 leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Internal Links */}
        <div className="mt-10 pt-6 border-t border-zinc-200">
          <p className="text-sm font-bold text-zinc-900 mb-3">Pautan Berkaitan</p>
          <div className="flex flex-wrap gap-2">
            <Link to="/smm-panel-malaysia" className="text-xs text-violet-600 bg-violet-50 px-3 py-1.5 rounded-full hover:underline">SMM Panel Malaysia</Link>
            <Link to="/blog/apa-itu-smm-panel" className="text-xs text-violet-600 bg-violet-50 px-3 py-1.5 rounded-full hover:underline">Apa Itu SMM Panel?</Link>
            <Link to="/services" className="text-xs text-violet-600 bg-violet-50 px-3 py-1.5 rounded-full hover:underline">Senarai Servis</Link>
            <Link to="/signup" className="text-xs text-violet-600 bg-violet-50 px-3 py-1.5 rounded-full hover:underline">Daftar Percuma</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
